<template>
    <Layout>
        <div class="card">
            <div class="card-header">
                <h4 class="card-title">
                    <b-button v-b-tooltip.hover.top="$t('general.back')" class="me-2" size="sm" variant="outline-primary" @click="$router.go(-1)">
                        <i class="fas fa-long-arrow-alt-left"></i>
                    </b-button>
                    {{ $t('contact.modify', { id: model.m_id }) }}
                </h4>
            </div>
            <div class="card-body">
                <contact-form></contact-form>
            </div>
        </div>
        <div class="card">
            <div class="card-header">
                <b-row>
                    <b-col cols="12">
                        <div class="d-flex align-items-center justify-content-between">
                            <h6 class="mb-0">{{ $t('contact.address') }}</h6>
                            <div>
                                <input ref="file" type="file" @change="upload" class="d-none" />
                                <b-button-group class="ms-2" >

                                    <b-button variant="outline-primary" size="sm" :title="$t('contact.import')" @click="$refs.file.click()">
                                        <i class="fas fa-file-import"></i>
                                    </b-button>
                                    <b-button @click="downloadSample" variant="outline-dark" size="sm" :title="$t('contact.download_sample')">
                                        <i class="fas fa-file-excel"></i>
                                    </b-button>
                                </b-button-group>
                                <b-button-group class="ms-2" >
                                    <b-button variant="outline-primary" size="sm" :title="$t('contact.export')" @click="download">
                                        <i class="fas fa-file-export"></i>
                                    </b-button>
                                </b-button-group>
                                <b-button class="ms-2" variant="success" size="sm" @click="modal = true;">
                                    <i class="fas fa-user-plus me-2"></i>
                                    {{ $t('contact.add') }}
                                </b-button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="card-body">
                <b-row>
                    <b-col cols="12">
                        <b-table
                            :caption="$t('contact.address')"
                            :items="content"
                            :fields="fields"
                            responsive="sm"
                            per-page="0"
                            hover
                            head-variant="light"
                            show-empty
                            tfoot-class="pt-2"
                            :empty-text="$t('contact.empty_address')"
                            :busy="loading"
                        >
                            <template #table-busy>
                                <div class="text-center">
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">{{ $t('table.loading') }}...</span>
                                    </div>
                                </div>
                            </template>
                            <template #cell(actions)="data">
                                <b-button v-if="data.item.additional_data && !Array.isArray(data.item.additional_data)" size="sm" v-b-tooltip.hover.top="$t('table.show_additional_data')" variant="info" class="me-1" @click="showAdditionalData(data.item)">
                                    <i class="fas fa-list"></i>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover.top="$t('table.edit')" variant="dark" class="me-1" :to="$t('routes.address_edit').substr(0, $t('routes.address_edit').indexOf(':')) + data.item.m_id">
                                    <i class="fas fa-pencil-alt"></i>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover.top="$t('table.delete')" variant="danger" @click="destroy(data.item.m_id)">
                                    <i class="fas fa-trash"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
            </div>
        </div>
        <b-modal ref="contact-address-modal" centered body-bg-variant="light" v-model="modal">
            <template #modal-title>
                {{ $t('contact.add_address') }}
            </template>
            <address-form ref="address" modal></address-form>
            <template #modal-footer>
                <b-button size="sm" @click="$refs['contact-address-modal'].hide()">{{ $t('contact.close') }}</b-button>
                <b-button size="sm" variant="success" @click="$refs.address.save().then(() => $refs['contact-address-modal'].hide())">
                    <i class="fas fa-user-plus me-2"></i>
                    {{ $t('contact.add') }}
                </b-button>
            </template>
        </b-modal>
        <b-modal ref="additional-data-modal" centered body-bg-variant="light" v-model="additionalDataModal" @close="clearAdditionalDataModal"
            hide-footer
        >
            <template #modal-header>
                <div class="text-center w-100">
                    <h5 class="modal-title">
                        {{ $t('contact.additional_data') }}
                    </h5>
                    <p class="mb-0">
                        <small><i>{{ additionalDataTitle }}</i></small>
                    </p>
                </div>
            </template>
            <table class="table table-striped table-borderless table-hover">
                <tbody>
                    <tr v-for="(value, key) in additionalData" :key="key">
                        <td style="width: 1%" width="1%"><strong>{{ key }}</strong></td>
                        <td>{{ value }}</td>
                    </tr>
                </tbody>
            </table>
        </b-modal>
    </Layout>
</template>

<script>
import Layout from "../../layouts/table";
import {mapGetters} from "vuex";
import AddressForm from "@/views/pages/contact/address.form";
import ContactForm from "@/views/pages/contact/form";
import * as XLSX from 'xlsx';

export default {
    name: "ApiAccountForm",

    components: {
        Layout,
        AddressForm,
        ContactForm
    },

    computed: {
        ...mapGetters({
            list: 'contact/list',
            model: 'contact/item',
            content: 'contact/address/list',
            loading: 'contact/address/loading'
        }),

        fields: function () {
            return [
                {
                    key: "name",
                    label: this.$t('contact.name'),
                    thClass: 'gridjs-th',
                    sortable: true
                },
                {
                    key: "phone_number",
                    label: this.$t('contact.phone'),
                    thClass: 'gridjs-th',
                    sortable: true
                },
                {
                    key: "actions",
                    label: '',
                    thClass: 'gridjs-th',
                    tdClass: 'text-end'
                },
            ];
        },
    },

    data() {
        return {
            modal: false,
            file: null,
            additionalDataTitle: '',
            additionalData: {},
            additionalDataModal: false
        };
    },

    methods: {
        upload: function (event) {
            this.file = event?.target?.files?.[0]
            this.confirmImport()
        },

        confirmImport() {
            this.$bvModal.msgBoxConfirm(this.$t('table.confirm'), {centered: true, bodyClass: 'h3 text-center font-weight-bold', footerClass: 'bg-light justify-content-center', okTitle: this.$t('table.yes'), cancelTitle: this.$t('table.no')})
                .then(value => {
                    if (value === false) {
                        this.file = null
                    } else {
                        this.$store.dispatch('address/importList', {file: this.file, id: this.$route.params.id})
                    }
                    console.log(value);
                })
                .catch(err => {
                    // An error occurred
                    console.log(err)
                })
        },

        download: function () {
            this.$store.dispatch('address/exportList', this.$route.params.id);
        },

        destroy: function (id) {
            const h = this.$createElement
            const titleText = this.$t('table.confirm');
            const title = h('h5', { class: ['modal-title', 'text-light'], domProps: { innerHTML: '<i class="fas fa-exclamation-triangle me-2"></i>' + titleText }});
            const okText = this.$t('table.yes');
            const okTitle = h('span', {domProps: { innerHTML: '<i class="fas fa-trash me-2"></i>' + okText }})

            this.$bvModal.msgBoxConfirm(this.$t('table.confirm_delete'), {
                title: [title],
                titleClass: 'text-light',
                headerBorderVariant: 'danger',
                size: 'sm',
                buttonSize: 'sm',
                headerBgVariant: 'danger',
                headerTextVariant: 'light',
                bodyBgVariant: 'danger',
                bodyTextVariant: 'light',
                bodyClass: 'px-3 pb-3 pt-0',
                okVariant: 'light text-danger',
                okTitle: [okTitle],
                cancelTitle: this.$t('table.no'),
                cancelVariant: 'success',
                footerBgVariant: 'danger',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value === true) {
                        this.$store.dispatch('address/destroy', id);
                    }
                })
        },

        showAdditionalData: function (item) {
            this.additionalData = item.additional_data;
            this.additionalDataTitle = item.name + ' ' + item.phone_number;
            this.additionalDataModal = true;
        },

        clearAdditionalDataModal: function () {
            this.additionalData = {};
            this.additionalDataTitle = '';
            this.additionalDataModal = false;
        },

        downloadSample: async function () {
            // A minta a frontend public mappájában van, ezért nem a $axios-szal kérjük le (annak baseURL-je az API)
            const response = await fetch(`/download/sample.xlsx`);
            // Az xlsx egy zip fájl, amit az xlsx csomag beépített zip-kezelőjével (CFB) bontunk ki
            const zip = XLSX.CFB.read(new Uint8Array(await response.arrayBuffer()), { type: 'array' });

            // A lista extra mezői (additional_data) új oszlopokként a "Név" / "Telefonszám" (A1, B1) után
            const additional = this.model?.additional_data;
            const columns = (Array.isArray(additional) ? additional : JSON.parse(additional || '[]'))
                .filter(column => column !== null && String(column).trim() !== '');

            if (columns.length) {
                // A SheetJS community verziója mentéskor elveszíti a formázást, ezért a munkalap XML-jét
                // közvetlenül módosítjuk, így az eredeti stílusok, oszlopszélességek stb. megmaradnak
                const sheet = XLSX.CFB.find(zip, '/xl/worksheets/sheet1.xml');
                let xml = new TextDecoder().decode(new Uint8Array(sheet.content));

                const escape = value => String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
                const headerStyle = (xml.match(/<c r="B1"[^>]*\ss="(\d+)"/) || [])[1];
                const firstCol = 2; // C oszlop (0 alapú index)
                const lastCol = firstCol + columns.length - 1;

                const cells = columns.map((column, index) => {
                    const ref = XLSX.utils.encode_col(firstCol + index) + '1';
                    return `<c r="${ref}"${headerStyle ? ` s="${headerStyle}"` : ''} t="inlineStr"><is><t>${escape(column)}</t></is></c>`;
                }).join('');

                xml = xml
                    .replace(/(<row [^>]*r="1"[^>]*>[\s\S]*?)(<\/row>)/, `$1${cells}$2`)
                    .replace(/(<row [^>]*r="1"[^>]*\sspans=")\d+:\d+/, (match, prefix) => `${prefix}1:${lastCol + 1}`)
                    .replace(/<dimension ref="([^"]+)"\/>/, (match, ref) => {
                        const range = XLSX.utils.decode_range(ref);
                        range.e.c = Math.max(range.e.c, lastCol);
                        return `<dimension ref="${XLSX.utils.encode_range(range)}"/>`;
                    });

                // Az új oszlopok a B oszlop szélességét kapják
                const colWidth = (xml.match(/<col min="2" max="2" width="([\d.]+)"/) || [])[1];
                if (colWidth) {
                    xml = xml.replace('</cols>', `<col min="${firstCol + 1}" max="${lastCol + 1}" width="${colWidth}" customWidth="1"/></cols>`);
                }

                sheet.content = new TextEncoder().encode(xml);
            }

            const blob = new Blob([new Uint8Array(XLSX.CFB.write(zip, { fileType: 'zip', compression: true }))], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'sample.xlsx';
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 0);
        },
    },

    created() {
        const action = this.list && this.list.length ? 'choose' : 'fetchOne';

        this.$store.dispatch(`contact/${action}`, this.$route.params.id).then(response => {
            document.title = this.setTitle(this.$t('contact.modify', { id: response.m_id }));
            this.$store.dispatch(`contact/address/fetchList`, response.m_id);
        });
    }
}
</script>

<style scoped>
input::placeholder {
    color: lightgrey;
}
</style>
